import { apiCall } from "../helpers/api";

export const boosts = (params = {}) => dispatch => {
    params.path = params.path || "boosts";

    return dispatch(apiCall(params));
}